import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Box, Button } from '@/DesignSystem/Component';
import { AuthConfirmForm } from '@/Module/Auth/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { preparePageTitle } from '@/Module/Core/Helper';
import { IconArrowRight } from '@/Module/Icon';
const AuthConfirmContainer: FC = () => {
  const router = useRouter();
  const onBackClick = () => {
    router.back();
  };
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="AuthConfirmContainer.tsx">
        <title>{preparePageTitle('تایید شماره موبایل')}</title>
      </Head>

      <div className=" mx-auto my-8 flex h-[calc(100vh-64px)] max-w-[460px] flex-col justify-center gap-12  px-6 sm:mt-20 sm:h-auto md:flex-row">
        <Box color="secondary" className="relative flex max-w-full flex-1 flex-col border-4 border-blueFive p-4 md:px-8 md:pb-10 md:pt-4" data-sentry-element="Box" data-sentry-source-file="AuthConfirmContainer.tsx">
          <Button onClick={onBackClick} className="!justify-start !p-0" data-sentry-element="Button" data-sentry-source-file="AuthConfirmContainer.tsx">
            <IconArrowRight size="small" data-sentry-element="IconArrowRight" data-sentry-source-file="AuthConfirmContainer.tsx" />
          </Button>
          <div className="flex flex-1 flex-col">
            <Image width={140} height={116} src={`${FILE_BROWSER_URL}/img/logo-school.png`} alt="logo" className="mx-auto mb-4 mt-20 sm:mt-4" data-sentry-element="Image" data-sentry-source-file="AuthConfirmContainer.tsx" />
            <div className=" mb-2 flex items-center gap-1">
              <h3 className="text-xl font-extrabold ">کد تایید را وارد کنید</h3>
            </div>
            <AuthConfirmForm data-sentry-element="AuthConfirmForm" data-sentry-source-file="AuthConfirmContainer.tsx" />
          </div>
        </Box>
      </div>
    </>;
};
export default AuthConfirmContainer;